<template>
  <div class="ordercenter">
    <div class="examine-center">
      <div class="crumbsnav">
        <router-link tag="a" to="/partner/organlist">合作机构列表</router-link>><a href="javascript:void(0);">机构详情</a>
      </div>
      <div class="myinfo">
        <div class="fl">
          <div class="personal ">
            <label>企业名称</label><p>{{companyInfo.companyName}}</p>
          </div>
          <div class="personal ">
            <label>统一社会信用代码</label><p>{{companyInfo.organizationCode}}</p>
          </div>
          <div class="personal ">
            <label>详细地址</label><p>{{companyInfo.companyAddr}}</p>
          </div>
          <div class="personal ">
            <label>法人姓名</label><p>{{companyInfo.legalName}}</p>
          </div>
          <div class="personal ">
            <label>身份证号</label><p>{{companyInfo.legalCardCode}}</p>
          </div>
        </div>
        <div class="fr">
          <div class="personal ">
            <label>代理人姓名</label><p>{{companyInfo.agentName}}</p>
          </div>
          <div class="personal ">
            <label>身份证号</label><p>{{companyInfo.agentCardCode}}</p>
          </div>
          <div class="personal ">
            <label>手机号</label><p>{{companyInfo.agentPhone}}</p>
          </div>
          <div class="personal ">
            <label>邮箱</label><p>{{companyInfo.agentEmail}}</p>
          </div>
          <div class="personal ">
            <label>授权书</label><p><a href="javascript:void(0);" @click="lookpic">查看授权书</a></p><!--letterAuthorization-->
          </div>
        </div>
        <p class="line"></p>
        <div class="fl">
          <div class="personal ">
            <label>账户名称</label><p>{{companyInfo.companyName}}</p>
          </div>
          <div class="personal ">
            <label>账户号码</label><p>{{companyInfo.bankNumber}}</p>
          </div>
          <div class="personal ">
            <label>开户银行</label><p>{{companyInfo.bankBranchName}}</p>
          </div>
          <div class="personal ">
            <label>联行号</label><p>{{companyInfo.bankCode}}</p>
          </div>
          <div class="personal qrodeset">
            <label>收款二维码</label><p><img :src="companyInfo.qrCode" class="qrcode" alt=""> <a href="javascript:void(0);" @click="lookpic">查看</a></p>
            <!--<a href="javascript:void(0);">上传<input type="file" class="uplicense imga" id="id"  ref="inputer"  @change="addImga($event,1)"   accept="image/png,image/jpeg,image/jpg"/></a>-->
          </div>
        </div>
      </div>
    </div>
    <div class="preview-zzc" v-if="picpreview" @click="closepreview"></div>
  </div>
</template>
<script>
const TIME_COUNT = 121
export default {
  data () {
    return {
      companyInfo:[],
      qrCode:'',
      picpreview:false
    }
  },
  mounted: function() {
    if(this.$route.params.companyinfo||localStorage.companydata){
      if(this.$route.params.companyinfo){
        this.companyInfo=this.$route.params.companyinfo
        localStorage.companydata = JSON.stringify(this.companyInfo)
      }
      else{
        this.companyInfo=JSON.parse(localStorage.companydata)
      }
    }else{
       this.$router.push({name:'OrganList'})
    }
  },
  methods: {
   closepreview(){
     this.picpreview=false
   },
   lookpic(){
     this.picpreview=true
   }
  },
  beforeDestroy(){
     localStorage.removeItem('companydata')
  }
}
</script>
<style  scoped>
.examine-center{
  width: 100%;
  height: auto;
  display: table;
  background: rgba(255,255,255,1);
  -webkit-box-shadow: 0px 3px 15px 0px rgba(0,0,0,0.06);
  box-shadow: 0px 3px 15px 0px rgba(0,0,0,0.06);
  border-radius: 8px;
  margin-top: 30px;
  padding-bottom: 30px;
}
.examine-center-tit{
  width:100%;
  height:56px;
  background:rgba(252,252,252,1);
  border-radius:4px 4px 0px 0px;
  border:1px solid rgba(227,228,229,1);
  text-indent: 24px;
  line-height:56px;
  color:rgba(51,51,51,1);
  font-size:18px;
}
.myinfo{
  width:90%;
  margin:30px auto;
}
.myinfo > div{
  width:50%;
}
.personal{
  width: 100%;
  clear: both;
  height:26px;
  line-height:26px;
  margin-bottom:15px;
  font-size: 14px;
  position: relative;
}
.personal label,.avatarset label{
  width:25.5%;
  float: left;
  text-align: right;
}
.personal p{
  width:50%;
  float: left;
  margin-left:3%;
  text-align:left;
}
.personal p > a{
  float: right;
  width:80px;
  color:#1381EF;
  text-decoration: underline;
}

.personal p{
  position: relative;
}

.qrodeset .uplicense{
  right:0;
}
.cursor{
  cursor: pointer;
}
.cursor a ,.cursor a input{
  cursor: pointer;
}
.personal p > a.changepass{
  margin-left: 42px;
  clear: both;
  float: none;
}
.loadstyle{
  position: absolute;
  right: 0;
  top:6px;
  width:20px;
  height:20px;
}

.smscode{
  width:80px;
  color:#3D8FE2;
  position: absolute;
  right:22px;
  top:2px;
  background: #fff;
  height:30px;
  cursor: pointer;
  text-align: center;
}
.seandtips{
  position: absolute;
  font-size: 12px;
  left:120px;
  top:31px;
  color:#FD5F39;
}
.seandtips:before {
    content: "\e7d5";
    font-size: 16px;
    margin-right:4px;
    color:#FD5F39;
    margin-top: -1px;
    display: block;
    float: left;
}
.qrcode{
  width:80px;
  height:80px;
}
.eyeview, .openeye {
  position: absolute;
  right:25px;
  top:0; 
  cursor: pointer;
}
.preview-zzc{
  width:100%;
  height:100%;
  height:100vh;
  position: fixed;
  left:0;
  top:0;
  bottom:0;
  right:0;
  background: rgba(0, 0, 0, 0.6)
}
</style>






// WEBPACK FOOTER //
// src/page/partner/organdetails.vue